import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { mapActions, mapState } from "pinia";
import { useDynamicUgcStore } from "~/stores/dynamic-ugc-store";
import { useAffiliateLinkStore } from "%/dynamic-component-editor/stores/affiliate-link-store";

export const ArticleEditorElementMixin = {
  extends: DynamicElementMixin,
  elementPanelSettings: {
    displayName: "Article Editor",
    displayIcon: "document",
    elementGroup: "articleElements",
    elementType: "element",
  },
  computed: {
    ...mapState(useDynamicUgcStore, [
      "title",
      "segments",
      "hashtags",
      "loadingHashtags",
      "loadingTitle",
      "loadingPublish",
      "savingStatus",
      "storyId",
      "loadingCreate",
      "userId",
    ]),
  },
  methods: {
    ...mapActions(useDynamicUgcStore, [
      "addHashtags",
      "removeHashtag",
      "create",
      "update",
      "setTitle",
      "uploadImageFunction",
      "uploadVideoFunction",
      "publishArticle",
      "unpublishArticle",
    ]),
    ...mapActions(useAffiliateLinkStore, [
      "searchAffiliateLinkProducts",
      "createLink",
    ]),
    async generateLinkRangesWithTrackingUrls(ranges, callback) {
      const promises = ranges.map(range => {
        return new Promise(resolve => {
          this.createLink(
            range.url,
            result => {
              if (result.short_link) {
                resolve({
                  ...range,
                  trackingUrl: result.short_link,
                  shortLinkData: result,
                });
              } else {
                resolve(range);
              }
            },
            () => {
              resolve(range);
            },
          );
        });
      });

      const results = await Promise.all(promises);
      callback(results);
    },
  },
};
